var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"SSOAccountBindingView text-secondary"},[_c('div',{staticClass:"text-center"},[(_vm.logoUrl)?_c('img',{staticClass:"logo",attrs:{"src":_vm.logoUrl,"alt":"logo"}}):_vm._e()]),_c('div',{key:_vm.$route.name,staticClass:"scene"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }